import { NavLink } from "react-router-dom";

export default function Sidebar() {
  return (
    <aside className="sidebar">
      <h2 className="logo">Zarkit</h2>

      <nav>
        <NavLink
          to="/dashboard"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Admin Panel
        </NavLink>

        <NavLink
          to="/users"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Users
        </NavLink>

        <NavLink
          to="/drivers"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Drivers
        </NavLink>

        <NavLink
          to="/VehicleCharges"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Vehicle Charge
        </NavLink>

        <NavLink
          to="/AllTrips"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          All Ride
        </NavLink>

        <NavLink
          to="/DriverWithdrawals"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Driver Withdrawals
        </NavLink>

        <NavLink
          to="/CancelRide"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Cancel Ride
        </NavLink>

        <NavLink
          to="/PendingRides"
          className={({ isActive }) => isActive ? "active" : ""}
        >
          Pending Rides
        </NavLink>

      </nav>
    </aside>
  );
}